import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const OCCASIONS = ["Work", "Dinner", "Date", "Wedding", "Party", "Casual", "Travel", "Formal Event", "Graduation", "Holiday"];
export const MATCH_CATEGORIES = ["Shirt / Top", "Shoes", "Jacket", "Accessories", "Complete Look"];

export const PERSONALITIES = [
  { id: "classic", label: "Classic", hint: "Timeless, refined, low-risk." },
  { id: "modern", label: "Modern", hint: "Contemporary but polished." },
  { id: "bold", label: "Bold", hint: "More expressive combinations." },
  { id: "surprise", label: "Surprise Me", hint: "Give MOIRÉ free rein." },
];

export const CATEGORIES = ["Tailored Trousers", "Jeans", "Shirt", "T-Shirt", "Blouse", "Dress", "Skirt", "Blazer", "Jacket", "Coat", "Knitwear", "Sneakers", "Loafers", "Heels", "Boots", "Handbag", "Accessory"];

export const PATTERNS = ["Solid", "Striped", "Checked", "Plaid", "Floral", "Geometric", "Printed", "Textured"];

export const COLOR_FAMILIES = [
  { name: "Black", hex: "#141414" }, { name: "White", hex: "#F7F5F0" },
  { name: "Grey", hex: "#9E9A92" }, { name: "Navy", hex: "#1F2A44" },
  { name: "Blue", hex: "#4C7BA6" }, { name: "Beige", hex: "#EDE4CE" },
  { name: "Brown", hex: "#5C4433" }, { name: "Green", hex: "#33513E" },
  { name: "Olive", hex: "#6B6A3B" }, { name: "Red", hex: "#7A2E2E" },
  { name: "Burgundy", hex: "#5B2333" }, { name: "Pink", hex: "#D9AFA6" },
  { name: "Purple", hex: "#5E3A5B" }, { name: "Yellow", hex: "#C99B3B" },
  { name: "Orange", hex: "#C46B4B" }, { name: "Teal", hex: "#2F6B6B" },
];

export const imageUrl = (path) => (path ? `${BACKEND_URL}${path}` : null);

export default api;
